import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: true, name: 'includes'})
export class IncludesPipe implements PipeTransform {
  transform<T>(array: T[] | undefined, value: T): boolean {
    if (!Array.isArray(array)) return false;
    return array.includes(value);
  }
}
